<template>
  <div>
    <!-- <div class="container">
      <div class="title display-3">Enter Your email Id</div>
      <FlashMessage :position="'right top'" />

      <form>
        <div>
          <div class="form-group">
            <label> </label>
            <input
              type="email"
              class="form-control"
              placeholder=" "
              v-model="email"
            />
          </div>
        </div>
        <button
          id="button"
          class="col-md-4 mx-auto d-block btn btn-secondary"
          v-on:click.prevent="posting"
        >
          submit
        </button>
      </form>
    </div> -->
    <div >
     <div class="mx-auto login-form">
       <FlashMessage :position="'right top'" />
        <form>
            <h2 class="text-center" >Reset Your Password</h2>       
            <div class="form-group">
                <input type="text" class="form-control" placeholder="Email Address" v-model="email" required="required">
            </div>
           
            <div class="form-group">
                <button type="submit" v-on:click.prevent="posting" class="btn btn-primary btn-block">Submit</button>
            </div>
                 
        </form>
    </div>
    </div>
  </div>
</template>

<script>
document.cookie = "cookie1=value1; SameSite=Lax";
// Set a cross-site cookie for third-party contexts
document.cookie = "cookie2=value2; SameSite=None; Secure";

import axios from "axios";
export default {
  data() {
    return {
      email: "",
    };
  },

  methods: {
    posting: function () {
      axios
        .post("https://pg-v1.herokuapp.com/resetpassword", {
          email: this.email,
        })
        .then((res) => {
          console.log(res);
          this.flashMessage.setStrategy("single");
          this.flashMessage.success({
            message: "Reset link send to your mail once check ",
            time: 3000,
            blockClass: "custom-block-class",
          });
          this.email=''
        })
        .catch((err) => {
          console.log(err.response);
          this.flashMessage.setStrategy("single");
          this.flashMessage.error({
            message: err.response.data.message,
            time: 3000,
            blockClass: "custom-block-class",
          });
        });
    },
  },
};
</script>

<style src='../assets/css/login.css' scoped >
.title {
  text-align: center;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin-left: auto;
  color: #2c3e50;
  margin-top: 200px;
  text-transform: capitalize;
  font-size: 2em;
}

.container {
  text-transform: capitalize;
}
</style>